import { Customer } from "./Customer";

type BaseProvider = {
  id: string;
  enabled: boolean;
  logo: string | null;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export enum ProviderName {
  Npayex = "Npayex",
}

export type Provider = BaseProvider &
  (
    | {
        name: string;
        config: Record<string, never>;
      }
    | {
        name: ProviderName.Npayex;
        config: NpayexConfig;
      }
  );

export class NpayexConfig {
  baseUrl: string;
  apiKey: string;
}

export type ProviderConfig = NpayexConfig | Record<string, never>; // Add other provider configs here

export type ProviderCustomerMatrix = {
  id: string;

  providerId: string;
  provider?: Provider;
  customerId: string;
  customer?: Customer;

  enabled: boolean;
  overrideConfig: ProviderConfig;

  createdAt: string | null;
  updatedAt: string | null;
};

// export type ProviderTransactionConfig = {};
